import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, { getName } from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import { SelectChangeEvent } from '@mui/material';
import React from "react";
import { Dayjs } from 'dayjs';

// Customizable Area Start
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  selectedDate: Date | null;
  userName: string;
  phone: string;
  emailAddress: string;
  gender: string;
  about: string;
  areasOfExpertise: string;
  dob: Dayjs | null;
  languages: string[];
  location: string;
  cityy: string;
  countryCode: string;
  callingCode: string;
  emailError: string;
  userNameError: string;
  isOpen: boolean;
  profileImage: string | null,
  isOpenDate: boolean;
  // Customizable Area End
}

interface SS {
  id: any;
  // Customizable Area Start
  // Customizable Area End
}

export default class CustomisableUserProfilesController extends BlockComponent<Props, S, SS> {
  // Customizable Area Start
  // Customizable Area End
  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);
    this.subScribedMessages = [
      // Customizable Area Start
      getName(MessageEnum.RestAPIResponceDataMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
      getName(MessageEnum.RestAPIResponceMessage)
      // Customizable Area End
    ];

    this.state = {
      // Customizable Area Start
      selectedDate: null,
      userName: "",
      phone: "1231232121",
      emailAddress: "",
      gender: "",
      about: "",
      areasOfExpertise: "",
      dob: null,
      languages: [],
      location: "",
      cityy:  "",
      countryCode: "DE",
      callingCode: "49",
      emailError: "Please enter valid email address",
      userNameError: "This field can't be empty",
      isOpen: false,
      profileImage: null,
      isOpenDate: false,
      // Customizable Area End
    };
    // Customizable Area Start
    this.fileInputRef = React.createRef<HTMLInputElement>();
    // Customizable Area End
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  async componentDidMount() {
    super.componentDidMount();
    // Customizable Area Start

    // Customizable Area End
  }

  fileInputRef: React.RefObject<HTMLInputElement> = React.createRef();

  async receive(from: string, message: Message) {
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start

  handleUserNameChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const userName = e.target.value;
  const formattedUserName = userName.replace(/\b([a-zA-Z])/g, (match, firstChar) => {
    return firstChar.toUpperCase();
  });
  this.setState({
    userName: formattedUserName,
    userNameError: formattedUserName.trim() === "" ? "This field can't be empty" : ""
  })
}

  handleEmailChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    this.setState({
      emailAddress: e.target.value
    }, this.validateEmailAddress)
  }

  handleAboutChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    this.setState({
      about: e.target.value
    })
  }

  handleAreasOfExpertiseChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    this.setState({
      areasOfExpertise: e.target.value
    })
  }

  handleGenderChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    this.setState({
      gender: e.target.value
    })
  }

  handleLocationChange = (e: SelectChangeEvent<string>) => {
    this.setState({
      location: e.target.value
    })
  }

handleLanguagesChange = (e: SelectChangeEvent<string[]>) => {
  const newLanguages = Array.isArray(e.target.value) ? e.target.value : [e.target.value];
  if (newLanguages.every(lang => this.state.languages.includes(lang))) {
    this.setState({ isOpen: false });
    return;
  }
  this.setState({ languages: newLanguages });
  this.setState({ isOpen: false }); 
};

removeLanguage = (languageToRemove: string) => {
  console.log("remove language called")
  this.setState({
    languages: this.state.languages.filter(lang => lang !== languageToRemove)
  });
};

  handleCityChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    this.setState({
      cityy: e.target.value
    })
  }

  validateEmailAddress = () => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    this.setState({
      emailError: emailPattern.test(this.state.emailAddress) && this.state.emailAddress !== ""
        ? "" 
        : "Please enter valid email address"
    });
  };

  formatPhoneNumber = (phone: string | any[]) => {
    if (phone.length > 6) {
      return `${phone.slice(0, 3)} ${phone.slice(3, 6)} ${phone.slice(6)}`;
    } else if (phone.length > 3) {
      return `${phone.slice(0, 3)} ${phone.slice(3)}`;
    }
    return phone;
  };

  handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (event) => {
        if (event.target) {
          this.setState({ profileImage: event.target.result as string });
        }
      };
      reader.readAsDataURL(file);
      if (this.fileInputRef.current) {
        this.fileInputRef.current.value = '';
      }
    }
  };

  handleDateChange = (newValue: Dayjs | null) => {
    this.setState({ dob: newValue });
  };
  
  // Customizable Area End
}
